import { ExternalLink, Building2, Handshake, Globe2 } from 'lucide-react';
import { useLang } from '../i18n/LanguageContext';

export default function Partnership() {
  const { t } = useLang();
  const bodyParts = t('partnership.body').split('{strong}');
  return (
    <section id="partenariat" className="py-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img src="/assets/qianyan-building.webp" alt="Qianyan Holdings" className="w-full h-[480px] object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/90 via-brand-navy/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                <div className="flex items-center gap-2 mb-3">
                  <Building2 className="w-5 h-5 text-brand-yellow" />
                  <span className="text-brand-yellow text-xs font-bold tracking-widest uppercase">{t('partnership.badgeLeft')}</span>
                </div>
                <div className="text-2xl md:text-3xl font-bold">Qianyan Holdings (Shenzhen) Group Co. Ltd.</div>
                <div className="text-white/70 text-sm mt-2">{t('partnership.subtitle')}</div>
              </div>
            </div>

            <div className="absolute -top-6 -right-6 md:-right-8 bg-brand-yellow rounded-2xl p-6 shadow-xl hidden md:block">
              <div className="text-brand-navy text-3xl font-black leading-none">{t('partnership.floating1')}</div>
              <div className="text-brand-navy/80 text-xs font-medium mt-1">{t('partnership.floating2')}</div>
            </div>
          </div>

          <div>
            <span className="section-label mb-4">{t('partnership.label')}</span>
            <h2 className="text-4xl md:text-5xl font-bold text-brand-navy mt-4 mb-6 leading-tight">
              {t('partnership.title1')} <br />
              <span className="yellow-underline">{t('partnership.title2')}</span>
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              {bodyParts[0]}<strong>{t('partnership.bodyStrong')}</strong>{bodyParts[1]}
            </p>

            <div className="space-y-4 mb-8">
              {t('partnership.benefits').map((b, i) => {
                const Ic = [Handshake, Globe2, Building2][i];
                return (
                  <div key={i} className="flex gap-4">
                    <div className="shrink-0 w-11 h-11 rounded-lg bg-brand-yellow/15 border border-brand-yellow/40 flex items-center justify-center">
                      <Ic className="w-5 h-5 text-brand-navy" />
                    </div>
                    <div>
                      <div className="font-semibold text-brand-navy">{b.t}</div>
                      <div className="text-sm text-gray-600 mt-1">{b.d}</div>
                    </div>
                  </div>
                );
              })}
            </div>

            <a href="https://qianyanholding.com" target="_blank" rel="noopener noreferrer" className="btn-yellow">
              {t('partnership.visit')} <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
